import type { RegistryEntry } from '../types';

export const bytedanceConfigs: Record<string, RegistryEntry> = {
  'seed-2.0-speech-tts': {
    options: [
      {
        key: 'output_format',
        label: 'audio.output_format',
        type: 'select',
        options: [
          { label: 'MP3', value: 'mp3' },
          { label: 'Opus', value: 'opus' },
        ],
        default: 'mp3',
        group: 'basic',
      },
      {
        key: 'sample_rate',
        label: 'audio.sample_rate',
        type: 'select',
        options: [
          { label: '8000 Hz', value: '8000' },
          { label: '16000 Hz', value: '16000' },
          { label: '22050 Hz', value: '22050' },
          { label: '24000 Hz', value: '24000' },
          { label: '32000 Hz', value: '32000' },
          { label: '44100 Hz', value: '44100' },
          { label: '48000 Hz', value: '48000' },
        ],
        default: '24000',
        group: 'basic',
      },
      {
        key: 'speed',
        label: 'audio.speed',
        type: 'slider',
        min: 0.5,
        max: 2,
        step: 0.01,
        default: 1,
        group: 'basic',
      },
      {
        key: 'volume',
        label: 'audio.volume',
        type: 'slider',
        min: 0.5,
        max: 2,
        step: 0.01,
        default: 1,
        group: 'basic',
      },
      {
        key: 'pitch',
        label: 'audio.pitch',
        type: 'slider',
        min: -12,
        max: 12,
        step: 1,
        default: 0,
        group: 'advanced',
      },
    ],
    toProviderOptions: (ui) => ({
      output_format: typeof ui.output_format === 'string' ? ui.output_format : 'mp3',
      sample_rate:
        typeof ui.sample_rate === 'string'
          ? Number(ui.sample_rate)
          : typeof ui.sample_rate === 'number'
            ? ui.sample_rate
            : 24000,
      speed: typeof ui.speed === 'number' ? ui.speed : 1,
      volume: typeof ui.volume === 'number' ? ui.volume : 1,
      pitch: typeof ui.pitch === 'number' ? ui.pitch : 0,
    }),
  },
};
